var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card mb-3 mb-lg-5"},[_vm._m(0),_c('div',{staticClass:"card-body"},[_c('drop-file')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header card-header-content-between"},[_c('h4',{staticClass:"card-header-title"},[_vm._v("Media")])])
}]

export { render, staticRenderFns }